
export enum EsignatureFlowType {
    GetStarted = "GetStarted",
    WhatsNext = "WhatsNext",
    ReviewDocument = "ReviewDocument",
    EnvelopeView = "EnvelopeView",
    EsignatureComplete = "EsignatureComplete",
    Dashboard = "Dashboard",
    PageOne = "PageOne",
    PageTwo = "PageTwo",
    VerifyIdentity = "VerifyIdentity",
    CompleteDocumentTasks = "CompleteDocumentTasks",
    SendFinishedDocument = "SendFinishedDocument"
}
